export default __webpack_public_path__ + "static/media/fail_test.fe377313.png";